import React from 'react'

interface Props {
  isSatelliteView: boolean
  toggleSatelliteView: () => void
}

const SatelliteViewControl: React.FC<Props> = ({
  toggleSatelliteView,
  isSatelliteView
}) => {
  return (
    <button
      type="button"
      title="Satellite View"
      aria-label="Satellite View"
      onClick={toggleSatelliteView}
    >
      <span
        className={`mapboxgl-ctrl-button material-icons ${
          isSatelliteView ? 'on' : ''
        }`}
      >
        public
      </span>
    </button>
  )
}

export default SatelliteViewControl
